import './TabsModule.less';
export { default as TabsModule } from './TabsModule';
export { default } from './TabsModule';